module.exports = __webpack_public_path__ + "img/brown-wooden-stool-3236265.2168d088.jpg";